import { useEffect, useState } from "react";

/**
 * Master v5 Prompt 16 — topbar clock. Originally always
 * America/Sao_Paulo (Session.coach_timezone's original default — see
 * session_contracts.py). Master v5 Prompt 31.1 lets a coach set their
 * own timezone, so this now shows that saved preference and falls
 * back to the original São Paulo default when unset.
 */
export function SaoPauloClock({ timezone }) {
  const [now, setNow] = useState(() => new Date());
  const tz = timezone || "America/Sao_Paulo";

  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 30000);
    return () => clearInterval(id);
  }, []);

  const time = now.toLocaleTimeString("en-US", { timeZone: tz, hour: "2-digit", minute: "2-digit" });
  const label = tz.split("/").pop().replace(/_/g, " ");

  return (
    <div className="hidden sm:flex flex-col items-end leading-tight px-1" data-testid="coach-sao-paulo-clock">
      <span className="text-sm font-medium text-ink" data-testid="coach-sao-paulo-clock-time">{time}</span>
      <span className="text-[10px] text-ink-soft">{label}</span>
    </div>
  );
}
